/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Confirm_Auto_ApprovedInputs */



/**
* | output |
* | --- |
* | "Auto-approved" |
*
* @param {Chat_Tool_Confirm_Auto_ApprovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_confirm_auto_approved = /** @type {((inputs?: Chat_Tool_Confirm_Auto_ApprovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Confirm_Auto_ApprovedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatisch genehmigt")
	return /** @type {LocalizedString} */ ("Auto-approved")
});